import { createClient } from '@supabase/supabase-js'

// Support both browser (Vite) and Node.js (Trigger.dev) environments
let supabaseUrl: string | undefined
let supabaseKey: string | undefined

// Check if we're in a browser/Vite environment (import.meta exists)
if (typeof import.meta !== 'undefined' && import.meta.env) {
  supabaseUrl = import.meta.env.VITE_SUPABASE_URL
  supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY
} else if (typeof process !== 'undefined' && process.env) {
  // Node.js environment (Trigger.dev). Guarded so a stray reference to `process`
  // in the browser doesn't throw ReferenceError before the placeholder fallback
  // below kicks in.
  supabaseUrl = process.env.VITE_SUPABASE_URL
  supabaseKey = process.env.VITE_SUPABASE_ANON_KEY
}

if (!supabaseUrl || !supabaseKey) {
  // For Trigger.dev deployment, we'll create a dummy client that will be
  // overridden at runtime with proper env vars from the dashboard
  console.warn('Missing Supabase environment variables - using placeholder values for build')
  supabaseUrl = supabaseUrl || 'https://placeholder.supabase.co'
  supabaseKey = supabaseKey || 'placeholder-key'
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  }
})